import React from "react";
import { Box } from "@chakra-ui/react";
import { FillImage } from "components/images";
import { horizontalContainerPadding } from "ui/container";
import { MediaAccordion } from "ui/accordion";
import { TextTitle } from "ui/text";
import firstAccordionImage from "../../../../public/assets/platform/ai-decisioning/accordion-1.png";
import secondAccordionImage from "../../../../public/assets/platform/ai-decisioning/accordion-2.png";
import thirdAccordionImage from "../../../../public/assets/platform/ai-decisioning/accordion-3.png";
import fourthAccordionImage from "../../../../public/assets/platform/ai-decisioning/accordion-4.png";

const accordionItems = [
  {
    title: "Analyze historical customer behavior",
    content:
      "We review all of the customer records in your data warehouse and apply user-level predictions and scores across attributes and behaviors.",
    media: (
      <FillImage
        src={firstAccordionImage}
        alt="Customer data for John Doe, displaying loyalty customer, age, state, LTV, and last purchase values."
      />
    ),
  },
  {
    title: "Decide the best content to send",
    content:
      "AI Decisioning pulls from your content library and matches messages with each customer based on their probability of taking an action.",
    media: (
      <FillImage
        src={secondAccordionImage}
        alt="Personalized content mapping options like 'Welcome offer', 'Daily offer', 'Hot deals', and more to individual customers."
      />
    ),
  },
  {
    title: "Pick the right timing and channel",
    content:
      "AI Decisioning assigns customers to specific marketing experiences at optimal frequencies, times of day, and channels.",
    media: (
      <FillImage
        src={thirdAccordionImage}
        alt="Personalization insights dashboard visualizing user attributes, messages, and confidence percentages."
      />
    ),
  },
  {
    title: "Test & learn across every customer",
    content:
      "AI Decisioning studies how customers react to every message, updates millions of predictions and surfaces insights on patterns in a dashboard.",
    media: (
      <FillImage
        src={fourthAccordionImage}
        alt="Illustration of AI Decisioning dashboard for an apparel retailer. The dashboard highlights user patterns across multiple products in relation to category affinity and click through rates."
      />
    ),
  },
];

export function FeatureAccordion() {
  return (
    <Box as="section" maxW="container.section" mx="auto" px={horizontalContainerPadding}>
      <TextTitle
        align="center"
        theme="dark"
        size="lg"
        maxW="3xl"
        descriptionMaxW="xl"
        title="1:1 customer journeys that test and optimize themselves"
        description="You drive the lifecycle strategy. AI agents deliver 1:1 experiences at scale. Here’s how it works."
      />
      <MediaAccordion
        mt={{ base: "big", md: "biggest" }}
        variant="dynamic"
        direction="right"
        theme="dark"
        items={accordionItems}
      />
    </Box>
  );
}
